import styled from "styled-components";

export const SeparatorLine = styled.div(({ theme }) => ({
    display: "block",
    borderTop: `1px dashed ${theme.colors[theme.colorMode].background_Button_Disabled}`,
    margin: `${theme.spacing.medium} 0`,
}));
